import React from 'react'
import { Box, Center, Flex, Heading, Image, Text } from '@chakra-ui/react'
import { useEffect } from 'react'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import AuthenticatedRoutes from '../../Utils/AuthenticatedRoutes'
import FunctionDropdown from '../Dropdown/FunctionDropdown'
import './Function.css'
import NavbarOpen from '../NavLinks/NavbarOpen'
const Function = ({ user }) => {
  const navigate = useNavigate()
  useEffect(() => {
    if (user & (user?.role !== null)) {
      navigate('/transcripts-summaries')
    }
  })
  return (
    <Box h='100vh'>
      <Box>
        <AuthenticatedRoutes auth={true} />
        <Box>
          <Flex>
            <Box
              w='50%'
              color='black'
              px='100px'
              h='100vh'
              justifyContent='flex-start'
            >
              <Flex direction='column' justifyContent='center'>
                <Box mt='40px'>
                  <Flex align='center'>
                    <Image src='/assets/images/logo.png' boxSize='20px' />
                    <Text
                      fontSize='20px'
                      fontWeight='500'
                      mx='10px'
                      color='black'
                    >
                      Arrowhead
                    </Text>
                  </Flex>
                </Box>
                <Box justifySelf='center' mt='20%'>
                  <Heading fontSize='5xl' maxW='426px' color='black' mb='20px'>
                    How will you be{' '}
                    <Box bg='#A423A9' display='inline' px={2} color='white'>
                      using
                    </Box>{' '}
                    Arrowhead?
                  </Heading>
                  <Text color='black' maxW='400px' mb='48px'>
                    Your Workplace is where you can find all your meetings and
                    discover your team. Invite your team.
                  </Text>
                  <Box>
                    <FunctionDropdown />
                  </Box>
                </Box>
              </Flex>
            </Box>
            <Center w='50%' bg='#E2D7F5' h='100vh' align='center'>
              <Box mt='-75px'>
                <Image
                  borderRadius='full'
                  boxSize='100px'
                  src='https://bit.ly/dan-abramov'
                  bg='white'
                  objectFit='cover'
                  mb='34px'
                />
                <Text color='black' px='200px' fontWeight={500} fontSize='21px'>
                  “A great tool for capturing and sharing customer feedback!”
                </Text>
              </Box>
            </Center>
          </Flex>
        </Box>
      </Box>
    </Box>
  )
}
const mapStateToProps = (state) => ({
  user: state?.user?.data,
})
export default connect(mapStateToProps)(Function)
